import { render, staticRenderFns } from "./MyArticleWebpart.vue?vue&type=template&id=4b8d1a93"
import script from "./MyArticleWebpart.ts?vue&type=script&lang=ts&external"
export * from "./MyArticleWebpart.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports